function getElementFontSize( context ) {
  // Returns a number
  return parseFloat(
    // of the computed font-size, so in px
    getComputedStyle(
      // for the given context
      context
      // or the root <html> element
        || document.documentElement
    )
    .fontSize
  );
}

function convertRem(value) {
  return convertEm(value);
}

function convertEm(value, context) {
  return value * getElementFontSize(context);
}

module.exports = convertRem;
